import React, { useState, useEffect, Fragment } from 'react';
import { Container, Row, Col, Card } from 'reactstrap';
import { connect } from 'react-redux';
import ReadUpdateIndicatorService from '../../../../../../../Service/DashboardServices/AccountOverviewServices/StoreServices/PartnerUpdateLog/ReadUpdateIndicatorService';
import PCSelectedStarIcon from '../../../../../../../designUtils/Storeoverview/PartnerLogs/PCSelectedStarIcon.svg';
import PCStarIcon from '../../../../../../../designUtils/Storeoverview/PartnerLogs/PCStarIcon.svg';
import PCArchiveIcon from '../../../../../../../designUtils/Storeoverview/PartnerLogs/PCArchiveIcon.svg';
import PCMarkAsReadIcon from '../../../../../../../designUtils/Storeoverview/PartnerLogs/PCMarkAsReadIcon.svg';
import Unarchive from '../../../../../../../designUtils/Storeoverview/PartnerLogs/Unarchive.svg';
import MarkAsUnread from '../../../../../../../designUtils/Storeoverview/PartnerLogs/MarkAsUnread.svg';
import UpdateFavMessageService from '../../../../../../../Service/DashboardServices/AccountOverviewServices/StoreServices/PartnerUpdateLog/UpdateFavNotificationsService';
import UpdateArchiveNotificationsService from '../../../../../../../Service/DashboardServices/AccountOverviewServices/StoreServices/PartnerUpdateLog/UpdateArchiveNotificationsService';
function ArchiveNotifications(props) {
    const [selectedTab, setSelectedTab] = useState('all');
    const [notificationDetails, setNotificationDetails] = useState([]);
    const [filteredNotifications, setFilteredNotifications] = useState([]);
    const [searchNoti, setSearchNoti] = useState('');
    const [notiCount, setNotiCount] = useState('0');
    const [actionNotiCount, setActionNotiCount] = useState('0');
    const [userFullName, setUserFullName] = useState('');
    const [pageSize, setPageSize] = useState(15);
    const [currentPage, setCurrentPage] = useState(0);
    const [archiveNotificationDetails, setArchiveNotificationDetails] = useState(props.archiveNotifications.details);
    const [archiveNotiCount, setArchiveNotiCount] = useState(props.archiveNotiCount);
 
    useEffect(()=>{
        console.log(props.archiveNotifications);
        setArchiveNotificationDetails(props.archiveNotifications.details)
        setArchiveNotiCount(props.archiveNotiCount)
    },[props.archiveNotifications])


    const [updatedRowIds, setUpdatedRowIds] = useState([]); // Store updated row IDs

    const handleFevMessage = (notifi) => {
      console.log("Updating notification:", notifi);
  
      const updatedNotification = { ...notifi, Favourite: !notifi.Favourite };
     
  
      UpdateFavMessageService(props.token, { id: notifi.id,searchparams:props.searchparams?props.searchparams:'' ,intId:props.store.integerID?props.store.integerID:0,})
          .then((res) => {
              if (res) {
                  console.log("API Response:", res);
                  props.setArchiveNotificationDetails((prevState) => {
                    const updatedDetails = prevState.details.map((item) =>
                        item.id === updatedNotification.id ? updatedNotification : item
                    );
                    return {
                        ...prevState,
                        details: updatedDetails,
                        // count: updatedCount,
                    };
                });
                  
  
                  // setUpdatedRowIds((prevIds) => [...new Set([...prevIds, updatedNotification.id])]);
              }
          })
          .catch(error => {
              console.error("Error updating notification:", error);
          });
  };
  

const handleRedirect = (notifi, flag) => {
  const wasUnread = notifi.Read_Indicator === false;
  const updatedNotification = { ...notifi, Read_Indicator: !notifi.Read_Indicator };
  const updateState = () => {
    props.setArchiveNotificationDetails((prevState) => {
        const updatedDetails = prevState.details.map((item) =>
            item.id === updatedNotification.id ? updatedNotification : item
        );

        let updatedCount = prevState.count;
        if (wasUnread && updatedNotification.Read_Indicator === true) {
            // Just marked as read → decrease count
            updatedCount -= 1;
        } else if (!wasUnread && updatedNotification.Read_Indicator === false) {
            // Just marked as unread → increase count
            updatedCount += 1;
        }

        return {
            ...prevState,
            details: updatedDetails,
            count: updatedCount,
        };
    });
};

    if (flag === 1 && notifi.redirectTo !== 'null') {
        if (notifi.Read_Indicator === false) {
            const data = { id: notifi.id ,
              intId:props.store.integerID?props.store.integerID:0,
              searchparams:props.searchparams?props.searchparams:''};
           

            ReadUpdateIndicatorService(props.token, data).then((res) => {
                if (res) {
                    console.log(res);
                    // Update the notification list in state
                    props.setArchiveNotificationDetails((prevState) => ({
                      ...prevState,
                      details: prevState.details.map((item) =>
                        item.id === updatedNotification.id ? updatedNotification : item
                      )
                    }));
                  
                }
            });
        }
        props.handleRedirctToComp(notifi)
        // const baseUrl = window.location.origin;
        // window.location.href = `${baseUrl}${notifi.redirectTo.startsWith('/') ? notifi.redirectTo : '/' + notifi.redirectTo}`;
    } else if (flag === 2) {
      
  
        const data = { id: notifi.id ,
          intId:props.store.integerID?props.store.integerID:0,
          searchparams:props.searchparams?props.searchparams:''
        };
        ReadUpdateIndicatorService(props.token, data).then((res) => {
            if (res) {
                console.log(res);
                updateState()
            }
        });
    } else {
        if (notifi.Read_Indicator === false) {
         
            const data = { id: notifi.id ,
              intId:props.store.integerID?props.store.integerID:0,
              searchparams:props.searchparams?props.searchparams:''
            };
            ReadUpdateIndicatorService(props.token, data).then((res) => {
                if (res) {
                    console.log(res);
                    updateState()
                }
            });
        }
    }

    // Update notification count based on the updated Read_Indicator
    // if (notifi.Read_Indicator === true) {
    //     props.setArchiveNotiCount((prevCount) => prevCount + 1);
    // } else {
    //     props.setArchiveNotiCount((prevCount) => prevCount - 1);
    // }
};

const handleArchiveMessage = (notifi) => {
  const wasArchived = notifi.Archive === true;
  const updatedNotification = { ...notifi, Archive: !notifi.Archive };
  const data = { id: [notifi.id],
    intId:props.store.integerID?props.store.integerID:0,
    searchparams:props.searchparams
   };

  UpdateArchiveNotificationsService(props.token, data).then((res) => {
      if (res) {
          console.log(res);

          props.setArchiveNotificationDetails((prevState) => {
              let updatedDetails;
              let updatedCount = prevState.count;

              if (wasArchived) {
                  // Unarchiving: remove from archived list
                  updatedDetails = prevState.details.filter(item => item.id !== updatedNotification.id);

                  // Only decrease count if it was unread
                  if (updatedNotification.Read_Indicator === false) {
                      updatedCount -= 1;
                  }
              } else {
                  // Archiving: add to archived list (if needed   depends on where you manage this)
                  // For archive screen, probably this case is irrelevant
                  updatedDetails = [...prevState.details, updatedNotification];

                  if (updatedNotification.Read_Indicator === false) {
                      updatedCount += 1;
                  }
              }

              return {
                  ...prevState,
                  details: updatedDetails,
                  count: updatedCount,
              };
          });
      }
  }).catch(err => {
      console.error("Error updating archive status:", err);
  });
};

  return (
    <Card className="card-of-problemarea p-3 ">
          <>
            {props.archiveNotifications && props.archiveNotifications.map((notifi, index) => {
                
              return (
                <Row key={index} className="row-hover-effect notification-item" style={{ cursor: 'pointer' }}>
                  <Col md={1} className="pt-1">
                    <h6>
                      <img
                        onClick={() => handleFevMessage(notifi)}
                        src={notifi.Favourite === true ? PCSelectedStarIcon : PCStarIcon}
                        alt="Icon"
                        className="star-icon"
                      />
                    </h6>
                  </Col>
                  <Col md={1}>
                    <Row>
                      <Col md={12} className="pt-1 ml-4 d-flex justify-content-center archive-item">
                       
                          <h6 className="mark-as-read-icon" onClick={() => handleArchiveMessage(notifi)}>
                            <img src={Unarchive} alt="Unarchive Icon" className="archive" title="Unarchive" />
                          </h6>
                       
                        {!notifi.Read_Indicator && (
                          <h6 className="ml-4 mark-as-read-icon" onClick={() => handleRedirect(notifi, 2)}>
                            <img src={PCMarkAsReadIcon} alt="Mark as Read Icon" className="mark-as-read" title="Mark as read" />
                          </h6>
                        )}
                        {notifi.Read_Indicator && (
                          <h6 className="ml-4 mark-as-read-icon" onClick={() => handleRedirect(notifi, 2)}>
                            <img src={MarkAsUnread} alt="Mark as Read Icon" className="mark-as-read" title="Mark as Unread" />
                          </h6>
                        )}
                      </Col>
                    </Row>
                  </Col>
                  <Col md={10} onClick={() => handleRedirect(notifi, 1)}>
                    <Row className='ml-2'>
                      <Col md={3} className="pt-0">
                        <h6 className={notifi.Read_Indicator === false ? 'bold-text' : 'normal-text'}>{notifi.createdAtFormated}</h6>
                      </Col>
                      <Col md={9} className="pt-0">
                        <h6 dangerouslySetInnerHTML={{ __html: notifi.Message }} className={notifi.Read_Indicator === false ? 'bold-text' : 'normal-text'}></h6>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12}>
                    <hr className="line-pg p-0 m-0"></hr>
                  </Col>
                </Row>
              );
            })}
          </>
        </Card>
  )
}
const mapStateToProps = (state) => {
    return {
      token: state.loggedUser.token,
      accessLevel: state.loggedUser.accessLevel,
      status: state.loggedUser.status,
      globalPermissions: state.loggedUser.globalPermissions,
      storeOverview: state.accountOverview.store.storeOverview,
      storeProducts: state.accountOverview.store.storeProducts,
      childProducts: state.accountOverview.store.childProducts,
      parentProducts: state.accountOverview.store.parentProducts,
      adProfiles: state.accountOverview.landing.adProfiles,
      roles: state.loggedUser.roles
    };
  };
  
  export default connect(mapStateToProps)(ArchiveNotifications);
